import { SuperSeniorReviewCtrl } from './super-senior-review.controller';

export const SuperSeniorReviewComponent = {
  controller: SuperSeniorReviewCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  template: require('./super-senior-review.html'),
};
